import { useEffect } from 'react'
import { useDataProvider, useNotify } from 'react-admin'
import { useForm } from 'react-final-form'
import { fetchLatestUtilityTariffForGroup, valuesForCreateFromCopiedUtilityRow } from './utilityTariffCreateHelpers'
import type { UtilityTariffDefaultCountry, UtilityTariffDefaultValueFunc } from './utilityTariffTypes'

type UtilityTariffCreateBootstrapProps = {
  defaultCountry: UtilityTariffDefaultCountry
  catalogueGroupUrl: string
  defaultValueFunc: UtilityTariffDefaultValueFunc
}

export function UtilityTariffCreateBootstrap({
  defaultCountry,
  catalogueGroupUrl,
  defaultValueFunc,
}: UtilityTariffCreateBootstrapProps) {
  const form = useForm()
  const dataProvider = useDataProvider()
  const notify = useNotify()

  useEffect(() => {
    if (!defaultCountry || !catalogueGroupUrl) {
      return undefined
    }
    let cancelled = false

    const load = async () => {
      try {
        const full = await fetchLatestUtilityTariffForGroup(dataProvider, catalogueGroupUrl)
        if (cancelled || full == null) {
          return
        }
        const cleaned = valuesForCreateFromCopiedUtilityRow(full, defaultCountry, catalogueGroupUrl, defaultValueFunc)
        form.batch(() => {
          Object.entries(cleaned).forEach(([key, value]) => {
            form.change(key, value)
          })
        })
      } catch {
        if (!cancelled) {
          notify('Could not load tariff to copy from', 'warning')
        }
      }
    }

    load()
    return () => {
      cancelled = true
    }
  }, [defaultCountry, catalogueGroupUrl, dataProvider, defaultValueFunc, form, notify])

  return null
}
